import { Form, FormInstance } from 'antd';
import { Button, Col, Colors, IcCashierSave, IcShow, IcTrash, Row, Text } from 'basic-ui-lib';
import styled from 'styled-components';
import { FormValues } from '../PlaylistForm';
import DragDropPlaylist from './DragDropPlaylist';
import BaseInput from 'basic-ui-lib/components/Input/BaseInput';
import { useDroppable } from '@dnd-kit/core';
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { setPageLoading } from 'widgets/PageLoading';
import playlistApis from 'modules/playlist/services/apis';
import toast from 'utils/toast';
import { getMessageError } from 'services/response';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';

interface ScreenPlaylistProps {
  form?: FormInstance<FormValues>;
  idPlaylist?: string;
}

const ScreenPlaylist = ({ form, idPlaylist }: ScreenPlaylistProps) => {
  const contentItems = Form.useWatch('contentItems', form) || [];
  const modalConfirmRef = useModalConfirmRef();

  const { setNodeRef } = useDroppable({
    id: 'PLAYLIST_DROP_ZONE',
    data: { type: 'PLAYLIST' },
  });

  const handleDeletePlaylist = async (playlistId: string) => {
    try {
      setPageLoading(true);
      const res = await playlistApis.deletePlaylist(playlistId);
      if(res?.data?.data) {
        toast.success('Playlist deleted successfully');
        // mutate({
        //   ...screensParams,
        // });
      }
    } catch (error) {
      toast.error(getMessageError(error));
    }
    finally {
      setPageLoading(false);
    }
  };

  const onDeletePlaylist = (playlistId: string) => {
    modalConfirmRef.current?.open(() => handleDeletePlaylist(playlistId), {
      message: 'Are you sure you want to delete this playlist? This action cannot be undone.',
    });
  };

  const totalDuration = useMemo(() => {
    return contentItems.reduce((sum, item) => sum + (item?.duration || 0), 0);
  }, [contentItems]);

  return (
    <Container>
      <Row padding='16px' justifyContent='space-between' alignItems='center' gap={24}>
        <Form.Item name='name' noStyle rules={[{ required: true, message: 'Please enter playlist name' }]}>
          <BaseInput placeholder='Playlist Name' />
        </Form.Item>
        <Row>
          {idPlaylist && (
            <Button
              type_delete
              prefix={<IcTrash width={20} height={20} fill={Colors.other[3]} />}
              onClick={() => onDeletePlaylist(idPlaylist)}
              lg
            >
              Delete
            </Button>
          )}
          <Button type_primary prefix={<IcShow width={20} height={20} fill={Colors.neutral.bg[1]} />} lg type='button'>
            Preview
          </Button>
          {idPlaylist ? (
            <Button
              type_second
              prefix={<IcCashierSave width={20} height={20} fill={Colors.neutral.bg[1]} />}
              lg
              type='submit'
            >
              Update
            </Button>
          ) : (
            <Button
              type_second
              prefix={<IcCashierSave width={20} height={20} fill={Colors.neutral.bg[1]} />}
              lg
              type='submit'
            >
              Save
            </Button>
          )}
        </Row>
      </Row>
      {/* <Form.Item name='duration' noStyle> */}
        <Col gap={0} padding='0 16px'>
          <Text body_1 regular color='neutral.text.3' left>
            Total Duration:
          </Text>
          <Text title_h5 medium left>
            {dayjs().startOf('day').add(totalDuration, 'second').format('HH:mm:ss')}
          </Text>
        </Col>
      {/* </Form.Item> */}
      <Content ref={setNodeRef}>
        <DragDropPlaylist />
      </Content>
      <ModalConfirm ref={modalConfirmRef} />
    </Container>
  );
};

export default ScreenPlaylist;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .custom-select {
    flex: 1;
    height: 64px;
  }
`;

const Content = styled.div`
  padding: 0 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
